import { FontAwesome5 } from '@expo/vector-icons';
import { secondaryFontFamily, styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import MDText from '../../atoms/md-text/md-text';
import { TestId } from '../../constants/test-id';
import { mt } from '../../style-utils';

export interface ErrorMessageBoxProps {
  text?: string;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}
export const ErrorMessageBox = ({
  text,
  style,
  testID = TestId.ERROR_MESSAGE_BOX,
}: ErrorMessageBoxProps) => {
  if (!text) return null;

  return (
    <Container style={style} testID={testID}>
      <View style={[mt(3)]}>
        <IconExclamationCircle />
      </View>
      <ErrorText fontFamily={secondaryFontFamily}>{text}</ErrorText>
    </Container>
  );
};

const Container = styled.View`
  border-radius: 5px;
  border-color: ${({ theme }) => theme.color.borderAccent};
  border-width: 1px;
  border-style: dashed;
  background-color: ${({ theme }) => theme.color.background};
  padding: 20px;
  flex-direction: row;
`;

const IconExclamationCircle = styled(FontAwesome5).attrs(({ theme }) => ({
  name: 'exclamation-circle',
  color: theme.color.danger,
  width: 16,
  height: 16,
}))``;

const ErrorText = styled(MDText).attrs(({ theme }) => ({
  color: theme.color.danger,
  size: 12,
}))`
  padding-left: 5px;
  margin-top: -10px;
  margin-bottom: -10px;
`;
